import React from 'react';
import styled from 'styled-components';
import { Flex } from '@dutchie/common/components/rebass-compat';
import Skeleton from '@material-ui/lab/Skeleton';
import {
  CheckoutLabel,
  CheckoutLabelGrouping,
  CheckoutBody,
  CheckoutSection,
  CheckoutSectionHeading,
} from 'checkout/components/styles/common';

function SectionsSkeleton() {
  return (
    <>
      <CheckoutSection>
        <CheckoutLabelGrouping id='order-1'>
          <CheckoutLabel>
            <CheckoutSectionHeading>
              <Skeleton height={16} width={70} />
            </CheckoutSectionHeading>
          </CheckoutLabel>
          <CheckoutBody>
            <FieldContainer>
              <InputSkeleton variant='rect' height={50} width='100%' />
              <Spacer />
              <InputSkeleton variant='rect' height={50} width='100%' />
            </FieldContainer>
            <FieldContainer>
              <InputSkeleton variant='rect' height={50} width='100%' />
            </FieldContainer>
            <FieldContainer>
              <InputSkeleton variant='rect' height={50} width='100%' />
            </FieldContainer>
            <FieldContainer>
              <Flex>
                <CheckboxSkeleton variant='rect' height={17} width={17} />
                <Skeleton height={13} width={150} />
              </Flex>
            </FieldContainer>
          </CheckoutBody>
        </CheckoutLabelGrouping>
      </CheckoutSection>
      <CheckoutSection>
        <CheckoutLabelGrouping id='order-2'>
          <CheckoutLabel>
            <CheckoutSectionHeading>
              <Skeleton height={16} width={70} />
            </CheckoutSectionHeading>
          </CheckoutLabel>
          <CheckoutBody>
            <AccordionSkeleton variant='rect' height={135} width='100%' />
          </CheckoutBody>
        </CheckoutLabelGrouping>
      </CheckoutSection>
      <CheckoutSection>
        <CheckoutLabelGrouping id='order-3'>
          <CheckoutLabel>
            <CheckoutSectionHeading>
              <Skeleton height={16} width={70} />
            </CheckoutSectionHeading>
          </CheckoutLabel>
          <CheckoutBody>
            <AccordionSkeleton variant='rect' height={100} width='100%' />
          </CheckoutBody>
        </CheckoutLabelGrouping>
      </CheckoutSection>
      <CheckoutSection>
        <CheckoutLabelGrouping id='order-4'>
          <CheckoutLabel>
            <CheckoutSectionHeading>
              <Skeleton height={16} width={70} />
            </CheckoutSectionHeading>
          </CheckoutLabel>
          <CheckoutBody>
            <AccordionSkeleton variant='rect' height={54} width='100%' />
          </CheckoutBody>
        </CheckoutLabelGrouping>
      </CheckoutSection>

      <CheckoutSection>
        <CheckoutLabelGrouping id='order-summary'>
          <CheckoutLabel>
            <CheckoutSectionHeading>
              <Skeleton height={16} width={70} />
            </CheckoutSectionHeading>
          </CheckoutLabel>
          <CheckoutBody>
            <SummaryItemContainer justifyContent='space-between' alignItems='center'>
              <div>
                <Skeleton height={13} width={170} />
                <Skeleton height={13} width={80} />
              </div>
              <Flex>
                <Skeleton height={13} width={50} />
                <Spacer />
                <Skeleton variant='circle' height={15} width={15} />
              </Flex>
            </SummaryItemContainer>
            <SummaryItemContainer justifyContent='space-between' alignItems='center'>
              <div>
                <Skeleton height={13} width={170} />
                <Skeleton height={13} width={80} />
              </div>
              <Flex>
                <Skeleton height={13} width={50} />
                <Spacer />
                <Skeleton variant='circle' height={15} width={15} />
              </Flex>
            </SummaryItemContainer>
            <SummaryItemContainer justifyContent='space-between' alignItems='center'>
              <div>
                <Skeleton height={13} width={170} />
                <Skeleton height={13} width={80} />
              </div>
              <Flex>
                <Skeleton height={13} width={50} />
                <Spacer />
                <Skeleton variant='circle' height={15} width={15} />
              </Flex>
            </SummaryItemContainer>
            <Flex mt='30px'>
              <Skeleton height={13} width={120} />
            </Flex>
          </CheckoutBody>
        </CheckoutLabelGrouping>
      </CheckoutSection>
    </>
  );
}
export default SectionsSkeleton;

const FieldContainer = styled(Flex)`
  max-width: 390px;
  margin-bottom: 17px;
  width: 100%;
  justify-content: space-between;

  &:last-of-type {
    margin-bottom: 0px;
    padding-top: 1px;
  }
`;

const Spacer = styled.div`
  min-width: 15px;
`;

const InputSkeleton = styled(Skeleton)`
  border-radius: 4px;
`;

const CheckboxSkeleton = styled(Skeleton)`
  border-radius: 4px;
  margin-right: 15px;
`;

const AccordionSkeleton = styled(Skeleton)`
  max-width: 390px;
  border-radius: 4px;
`;

const SummaryItemContainer = styled(Flex)`
  border-bottom: 1px solid var(--dcm-checkout-summary-border-color, #e4e8ea);
  max-width: 390px;
  height: 80px;
`;
